/** `flow=onboarding` is set only on the welcome email link; anything else is a reset. */
export type PasswordLinkFlow = 'onboarding' | 'reset';

export const getPasswordLinkFlow = (value: string | null): PasswordLinkFlow =>
  value === 'onboarding' ? 'onboarding' : 'reset';
